import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  syncAIPanelVisible: boolean;
  syncAIPipelineSessionId: string | null;
}

const initialState: UIState = {
  syncAIPanelVisible: false,
  syncAIPipelineSessionId: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSyncAIPanelVisible: (state, action: PayloadAction<boolean>) => {
      state.syncAIPanelVisible = action.payload;
    },
    setSyncAIPipelineSessionId: (state, action: PayloadAction<string | null>) => {
      state.syncAIPipelineSessionId = action.payload;
    },
  },
});

export const { setSyncAIPanelVisible, setSyncAIPipelineSessionId } = uiSlice.actions;
export default uiSlice.reducer;
